(() => {
  const selectors = [
    '.media-with-content:has(a[href*="instagram.com/reevam_store"]) .media-block video',
    '[class*="ai-image-text-"] video'
  ];
  const videos = new Set();
  for (const selector of selectors) {
    try {
      document.querySelectorAll(selector).forEach((video) => videos.add(video));
    } catch (_) {}
  }
  if (!videos.size) return;

  const isNearViewport = (video) => {
    const rect = video.getBoundingClientRect();
    const margin = 220;
    return rect.bottom >= -margin && rect.top <= window.innerHeight + margin &&
      rect.right >= 0 && rect.left <= window.innerWidth;
  };

  const attemptPlayback = (video) => {
    if (!video.isConnected || document.visibilityState === 'hidden' ||
        video.dataset.reevamAutoplayStarted === 'true' ||
        !isNearViewport(video)) return;

    /* Muted inline playback is the browser-supported route for background-style video. */
    video.muted = true;
    video.defaultMuted = true;
    video.volume = 0;
    video.playsInline = true;
    video.loop = true;
    video.preload = 'auto';
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.setAttribute('autoplay', '');
    video.setAttribute('loop', '');

    let playResult;
    try {
      playResult = video.play();
    } catch (_) {
      return;
    }
    if (playResult && typeof playResult.then === 'function') {
      playResult.then(() => {
        video.dataset.reevamAutoplayStarted = 'true';
        if (observer) observer.unobserve(video);
        video.removeEventListener('canplay', onCanPlay);
      }).catch(() => {
        /* Retry when the video enters view again or the visitor interacts with the page. */
      });
    } else {
      video.dataset.reevamAutoplayStarted = 'true';
      if (observer) observer.unobserve(video);
      video.removeEventListener('canplay', onCanPlay);
    }
  };

  const canPlayHandlers = new Map();
  const onCanPlay = (event) => attemptPlayback(event.currentTarget);

  const observer = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) attemptPlayback(entry.target);
        }
      }, { rootMargin: '220px 0px', threshold: 0.01 })
    : null;

  videos.forEach((video) => {
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.loop = true;
    video.preload = 'auto';
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.setAttribute('autoplay', '');
    video.setAttribute('loop', '');
    video.addEventListener('canplay', onCanPlay);
    canPlayHandlers.set(video, onCanPlay);
    if (video.readyState === 0) video.load();
    if (observer) observer.observe(video);
    attemptPlayback(video);
  });

  /* Some mobile browsers defer autoplay until the first user gesture. */
  document.addEventListener('pointerdown', () => {
    videos.forEach((video) => attemptPlayback(video));
  }, { passive: true });
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') videos.forEach((video) => attemptPlayback(video));
  });
  window.addEventListener('pageshow', () => videos.forEach((video) => attemptPlayback(video)));
})();